var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { ButtonBase } from '../ButtonBase/ButtonBase';
export var ButtonLink = styled(ButtonBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: transparent;\n\n  &,\n  &.MuiButton-root.Mui-disabled {\n    color: ", ";\n  }\n\n  &:hover {\n    background: transparent;\n    text-decoration: underline;\n  }\n"], ["\n  background: transparent;\n\n  &,\n  &.MuiButton-root.Mui-disabled {\n    color: ", ";\n  }\n\n  &:hover {\n    background: transparent;\n    text-decoration: underline;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.action;
});
var templateObject_1;
